import { Pill, Syringe, Flame } from 'lucide-react';

/**
 * Shared export filter options.
 * Single source of truth for the status filter and multi-category selector
 * used by the CSV, table, and image export modals.
 */
export const STATUS_OPTIONS = ['Active', 'Pending', 'Paused', 'Completed', 'All'];

export const DEFAULT_EXPORT_CATEGORIES = ['Supplement', 'Peptide', 'Hormones & AAS'];

export const CATEGORY_DEFS = [
  { id: 'Supplement', label: 'Supplements', icon: Pill, color: 'sky' },
  { id: 'Peptide', label: 'Peptides', icon: Syringe, color: 'purple' },
  { id: 'Hormones & AAS', label: 'Hormones & AAS', icon: Flame, color: 'rose' }
];
